import React, { useContext } from 'react';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { InputFormField } from './InputFormField';
import { inputLengthValidation } from './Validations';

export const BranchFormField = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData } = useContext(CodeRepoFormCtx);
  const updateBranch = (newValue: string) => ({ branch: newValue });
  const validations = [inputLengthValidation];
  return (
    <InputFormField
      fieldId="branch"
      label={
        <span>
          Branch <i>- optional</i>
        </span>
      }
      value={repoData.branch}
      setValue={updateBranch}
      validations={validations}
    />
  );
};
